import { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { request } from "../../../utils/api";
import Loading from "../utilComponent/Loading";
import Pagination from "../utilComponent/Pagination";

const WarehouseActivityModal = ({ show, onHide, row }) => {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  // const [pagination, setPagination] = useState({
  //   current_page: 1,
  //   per_page: 6,
  //   total: 0,
  //   last_page: 1,
  // });

  const fetchLogs = async () => {
    if (!row) return;

    try {
      setLoading(true);

      const response = await request({
        url: `warehouses/${row.warehouse_id}/activity-logs-warehouse-wise`,
        method: "GET",
      });

      if (response?.status) {
        const flattenedLogs =
          response.data.labels?.flatMap(label =>
            label.logs.map(log => ({
              ...log,
              label_name: label.label_name,
            }))
          ) || [];

        setLogs(flattenedLogs);
        // setPagination();
      }
    } catch (error) {
      toast.error("Failed to load activity logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [row]);

  // Reset page when modal opens
  // useEffect(() => {
  //   if (show) {
  //     setPagination((prev) => ({
  //       ...prev,
  //       current_page: 1,
  //     }));
  //   }
  // }, [show]);

  // const handlePageChange = (page) => {
  //   // setPagination((prev) => ({
  //   //   ...prev,
  //   //   current_page: page,
  //   // }));
  // };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered >
      <Modal.Header closeButton>
        <Modal.Title>Warehouse Activity Logs</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <Loading />
        ) : logs.length === 0 ? (
          <div className="text-center text-muted py-4">
            No activity logs found
          </div>
        ) : (
          <>
            <div className="row g-3">
              {logs.map((log, index) => (
                <div key={log.id || index} className="col-md-6">
                  <div className="card shadow-sm h-100">
                    <div className="card-body">
                      <h6 className="fw-bold mb-2">
                        {log.activity_description}
                      </h6>

                      <p className="mb-1">
                        <strong>Label:</strong> {log.metadata?.label_name}
                      </p>

                      <p className="mb-1">
                        <strong>Product:</strong> {log.metadata?.product_name}
                      </p>

                      <p className="mb-1">
                        <strong>SKU:</strong> {log.metadata?.product_sku}
                      </p>

                      <p className="mb-1">
                        <strong>User:</strong> {log.user_name}
                      </p>

                      <p className="mb-1">
                        <strong>Warehouse:</strong>{" "}  
                        {log.metadata?.warehouse_name}
                      </p>

                      <small className="text-muted">
                        {new Date(log.created_at).toLocaleString()}
                      </small>
                    </div>
                  </div>
                </div>
              ))}

            </div>

            {/* {pagination.last_page > 1 && (
              <div className="d-flex justify-content-end mt-4">
                <Pagination
                  currentPage={pagination.current_page}
                  lastPage={pagination.last_page}
                  onPageChange={handlePageChange}
                />
              </div>
            )} */}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default WarehouseActivityModal;
